import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@env/environment';

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const cookieService = inject(CookieService);

  const excludedUrls = [
    'https://api.ipify.org?format=json',
    // environment.apiUrlThirdParty,
    // environment.unblockApiUrlThirdParty,
    // environment.currentOutstandingUrlThirdParty
  ];

  if (excludedUrls.includes(req.url)) {
    return next(req);
  }

  const token = cookieService.get('jwtToken');

  const headers: { [key: string]: string } = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const clonedRequest = req.clone({
    setHeaders: headers,
  });

  return next(clonedRequest);
};
